<template>
  <Loader v-if="loading" />
  <div class="card">
    <div class="flex justify-content-between">
      <div class="col-2">
        <h4>Convenzioni Agf</h4>
      </div>
      <div class="col-10 flex justify-content-end">
        <Button label="Aggiungi convenzione" icon="pi pi-plus" @click="toggleNewConvenzioneCard"/>
      </div>
    </div>
    
    <!-- Nuova Card per aggiungere convenzione -->
    <div v-if="showNewConvenzioneCard" class="new-convenzione-card">
      <div class="new-convenzione-card-header">
        <h3>Crea nuova convenzione</h3>
        <Button icon="pi pi-times" class="p-button-text p-button-rounded" @click="toggleNewConvenzioneCard"/>
      </div>
      <div class="new-convenzione-card-content">
        <div class="flex flex-wrap justify-content-center">
          <div class="col-12 md:col-6">
            <label class="mb-2">Nome convenzione</label>
            <InputText v-model="new_convenzione.nome_convenzione" class="w-full"/>
            <small v-show="validationErrors.nome_convenzione" class="p-error">Campo necessario</small>
          </div>
          <div class="col-12 md:col-6">
            <label class="mb-2">Seleziona agente</label>
            <Dropdown v-model="new_convenzione.agente" :options="agenti_offerte" filter optionLabel="name" class="w-full" @change="onSelectionAgente($event)"/>
            <small v-show="validationErrors.agente" class="p-error">Campo necessario</small>
          </div>
          
          <div v-if="new_convenzione.agente" class="w-full flex">
            <div v-for="type_offerte in types_offerte" :key="type_offerte.value" class="col-6">
              <div class="flex col-12 align-items-center">
                <Checkbox v-model="type_offerte.selected" :binary="true"/>
                <label class="m-2">Offerta {{ type_offerte.name }}</label>
              </div>
              <div v-if="type_offerte.selected">
                <div class="col-12" v-for="type_offerta in type_offerte.offerte" :key="type_offerta.type">
                  <label class="mb-2">Seleziona offerta {{type_offerta.label}}</label>
                  <Dropdown v-model="new_convenzione.offerte[type_offerte.label][type_offerta.type]" :options="type_offerta.offerte" filter optionLabel="name" class="w-full"/>
                  <div class="mt-3 flex justify-content-around" v-if="new_convenzione.offerte[type_offerte.label][type_offerta.type]">
                    {{ getInfoOfferta(new_convenzione.offerte[type_offerte.label][type_offerta.type], 'tipologia', 1) }}
                  </div>
                  <small v-show="validationErrors[`offerta_${type_offerta.type}`]" class="p-error">Campo necessario</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 flex align-items-center">
            <Checkbox
              v-model="new_convenzione.internal"
              :binary="true"
              :true-value="1"
              :false-value="0"
            />
            <label class="m-2">Convenzione interna</label>
          </div>
          <div class="col-12 md:col-6 flex justify-content-center">
            <div class="button-wrapper mb-2">
              <span class="p-1 label flex align-items-center justify-content-center">Carica logo</span>
              <input class="upload-file" name="file[]" type="file" ref="file" @change="handleFile($event)" accept="image/jpeg,image/jpg,image/png"/>
            </div>
          </div>
          <div v-if="new_convenzione.file" class="m-1">File selezionato: {{ new_convenzione.file.name }}</div>
          <small v-show="validationErrors.file" class="p-error">Campo necessario</small>
          <div class="col-12 flex justify-content-center m-2">
            <Button label="Salva" icon="pi pi-check" @click="sendNewConvenzione" :disabled="isDisabledSendNewConvenzione"/>
          </div>
        </div>
      </div>
    </div>
    
    <div v-for="(group_convenzione, agente) in convenzioni" :key="agente" class="card flex justify-content-between align-items-center">
      <div class="col-2">{{ agente }}</div>
      <div class="col-10 flex flex-column">
        <div v-for="(convenzione, nome_convenzione) in group_convenzione" :key="nome_convenzione">
          <DataTable :value="convenzione" tableStyle="width: 100%">
            <template #header>
              {{ nome_convenzione }}
            </template>
            <Column header="Data creazione">
              <template #body="{data}">
                {{ moment(data.data_creazione).format('DD/M/Y') }}
              </template>
            </Column>
            <Column header="Url">
              <template #body="{data}">
                {{ data.internal == 1 ? services.ask_landing.url + '/internal/' + data.token : services.ask_landing.url + '/' + data.token }}
              </template>
            </Column>
            <Column field="name_offerta" header="Offerta"></Column>
            <Column header="Opzioni">
              <template #body="{data}">
                {{ getInfoOfferta(data) }}
              </template>
            </Column>
            <Column header="Azioni">
              <template #body="{data}">
                <Button
                  v-if="isConvenzioneInactive(data)"
                  label="Attiva"
                  icon="pi pi-check"
                  class="p-button-sm p-button-success"
                  :loading="activeConvenzioneLoading === data.id"
                  :disabled="activeConvenzioneLoading === data.id"
                  @click="setActiveConvenzione(data)"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
  <Dialog v-model:visible="dialog_create_convenzione" modal header="Crea convenzione" :style="{ width: '50%' }">
    <div class="flex flex-wrap justify-content-center">
      <div class="col-12 md:col-6">
        <label class="mb-2">Nome convenzione</label>
        <InputText v-model="new_convenzione.nome_convenzione" class="w-full"/>
        <small v-show="validationErrors.nome_convenzione" class="p-error">Campo necessario</small>
      </div>
      <div class="col-12 md:col-6">
        <label class="mb-2">Seleziona agente</label>
        <Dropdown v-model="new_convenzione.agente" :options="agenti_offerte" filter optionLabel="name" class="w-full" @change="onSelectionAgente($event)"/>
        <small v-show="validationErrors.agente" class="p-error">Campo necessario</small>
      </div>
      <div class="col-12 md:col-6 flex align-items-center">
        <Checkbox
          v-model="new_convenzione.internal"
          :binary="true"
          :true-value="1"
          :false-value="0"
        />
        <label class="m-2">Convenzione interna</label>
      </div>
      <div v-if="new_convenzione.agente" class="w-full flex">
        <div v-for="type_offerte in types_offerte" :key="type_offerte.value" class="col-6">
          <div class="flex col-12 align-items-center">
            <Checkbox v-model="type_offerte.selected" :binary="true"/>
            <label class="m-2">Offerta {{ type_offerte.name }}</label>
          </div>
          <div v-if="type_offerte.selected">
            <div class="col-12" v-for="type_offerta in type_offerte.offerte" :key="type_offerta.type">
              <label class="mb-2">Seleziona offerta {{type_offerta.label}}</label>
              <Dropdown v-model="new_convenzione.offerte[type_offerte.label][type_offerta.type]" :options="type_offerta.offerte" filter optionLabel="name" class="w-full"/>
              <div class="mt-3 flex justify-content-around" v-if="new_convenzione.offerte[type_offerte.label][type_offerta.type]">
                {{ getInfoOfferta(new_convenzione.offerte[type_offerte.label][type_offerta.type], 'tipologia', 1) }}
              </div>
              <small v-show="validationErrors[`offerta_${type_offerta.type}`]" class="p-error">Campo necessario</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 flex justify-content-center">
        <div class="button-wrapper mb-2">
          <span class="p-1 label flex align-items-center justify-content-center">Carica logo</span>
          <input class="upload-file" name="file[]" type="file" ref="file" @change="handleFile($event)" accept="image/jpeg,image/jpg,image/png"/>
        </div>
      </div>
      <div v-if="new_convenzione.file" class="m-1">File selezionato: {{ new_convenzione.file.name }}</div>
      <small v-show="validationErrors.file" class="p-error">Campo necessario</small>
      <div class="col-12 flex justify-content-center m-2">
        <Button label="Salva" icon="pi pi-check" @click="sendNewConvenzione" :disabled="isDisabledSendNewConvenzione"/>
      </div>
    </div>
  </Dialog>
</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line no-unused-vars
import {ref, onMounted, getCurrentInstance, computed } from 'vue';
import Loader from "@/components/Loader.vue"
import moment from 'moment'
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useToast } from 'primevue/usetoast';
import roles from '@/config/roles'
import { useRoute, useRouter } from 'vue-router'
import services from '@/config/services'

export default {
  components: {
    Loader
  },  
  setup (props, {emit}) {
    const toast = useToast();
    const loading = ref(false)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const convenzioni = ref({})
    const validationErrors = ref({})
    const dialog_create_convenzione = ref(false)
    const showNewConvenzioneCard = ref(false)
    const activeConvenzioneLoading = ref(null)
    
    const getData = async () => {
      loading.value = true  
      await service.getConvenzioni()
      .then((res)=>{
        convenzioni.value = res.items
      })
      .finally(()=> {
        loading.value = false
      })
    }
    
    const agenti_offerte = ref([])
    const getAgentiOfferte = async () => {
      await service.getAgentiOfferte()
      .then((res)=>{
        agenti_offerte.value = res.items
      })
    }        
    const selectedAgente = ref()
    const offerte_elettrico = ref([])
    const offerte_gas = ref([])
    const onSelectionAgente = (evt) => {
      types_offerte.value.forEach(type_offerte => {
        type_offerte.selected = false
        type_offerte.offerte.forEach(type_offerta => {
          type_offerta.offerte = evt.value.offerte.filter(offerta => offerta.tipologia == type_offerta.id && offerta.cod_type_offerta == type_offerte.value)
        })
      })
    }

    const new_convenzione = ref({
      nome_convenzione: '',
      agente: null,
      offerte: {
        fix: {
          ee: null,
          gas: null,
        },
        index: {
          ee: null,
          gas: null
        }
      },
      internal: 0,
      file: null
    })
    const prop_to_send = {
      nome_convenzione: {prop: [], json: true},
      agente: {prop: ['id'], json: true},
      offerte: {prop: [], json: true},
      internal: {prop: [], json: false},
      // offerta_ee: {prop: ['id', 'f1', 'pcv', 'cod_type_offerta'], json: true},
      // offerta_gas: {prop: ['id', 'm', 'pcv', 'cod_type_offerta'], json: true},
      file: {prop: [], json: false},
    }
    
    const toggleNewConvenzioneCard = () => {
      showNewConvenzioneCard.value = !showNewConvenzioneCard.value
      if (!showNewConvenzioneCard.value) {
        resetNewConvenzione()
      }
    }
    
    const getInfoOfferta = (offerta, prop = 'type', type_prop = 'ee') => {            
      let type = offerta[prop]
      let type_unit = type == type_prop ? 'PUN' : 'PSV'
      let unit = type == type_prop ? 'Kwh' : 'Smc'
      let dato = type == type_prop ? offerta.f1.toFixed(2).replace('.', ',') : offerta.m.toFixed(2).replace('.', ',')
      let pcv = offerta.pcv
      return `PCV ${pcv} €/Mese - ${type_unit} ${dato} €/${unit}`
    }
    const types_offerte = ref([
      {value: 1,label: 'fix', name: 'Fissa', selected: false, offerte: [
        {id: 1, label: 'elettrico', type: 'ee', offerte:[]},
        {id: 2, label: 'gas', type: 'gas', offerte:[]}
      ]},
      {value: 2,label: 'index', name: 'Variabile', selected: false, offerte: [
        {id: 1, label: 'elettrico', type: 'ee', offerte:[]},
        {id: 2, label: 'gas', type: 'gas', offerte:[]}
      ]}
    ])

    onMounted(() => { 
      getAgentiOfferte()      
      getData()
    })
    const handleFile = (evt) => {
      new_convenzione.value.file = self.refs.file.files[0]
    };
    const sendNewConvenzione = async () => {
      
      // validationErrors.value = {}
      loading.value = true
      let fd = new FormData()
      Object.keys(new_convenzione.value).forEach(prop => {
        let data_prop = prop_to_send[prop]
        let name = prop == 'file' ? `${prop}[]` : prop
        let data
        
        if (data_prop.prop.length) {
          data = {}
          data_prop.prop.forEach(el => {              
            data[el] = new_convenzione.value[prop][el]
          })
        }else{
          data = new_convenzione.value[prop]
        }
                  
        fd.append(name, data_prop.json ? JSON.stringify(data) : data)
      })
      await service.sendNewConvenzione(fd)
      .then((res) => {
        let severity = res.item.success ? 'success' : 'warn'
        let detail = res.item.msg
        toast.add({severity: severity, detail: detail, life: 5000})
        resetNewConvenzione()
        showNewConvenzioneCard.value = false
      })
      .finally(()=>{
        getData()
        loading.value = false
      })
      // if (!validateForm()) {
      // }
    }
    const isConvenzioneInactive = (convenzione) => {
      return convenzione.active === false || convenzione.active === 0 || convenzione.active === '0'
    }
    const setActiveConvenzione = async (convenzione) => {
      if (!convenzione.id) {
        toast.add({severity: 'warn', detail: 'Id convenzione mancante', life: 5000})
        return
      }

      activeConvenzioneLoading.value = convenzione.id
      await service.setActiveConvenzione(convenzione.id)
      .then((res) => {
        let item = res.item || {}
        let success = item.success === true
        let detail = item.msg || item.message || (success ? 'Convenzione attivata correttamente' : 'Attivazione convenzione non riuscita')
        let severity = success ? 'success' : 'warn'
        toast.add({severity: severity, detail: detail, life: 5000})
      })
      .finally(()=> {
        getData()
        activeConvenzioneLoading.value = null
      })
    }
    // const validateForm = () => {
    //   Object.keys(new_convenzione.value).forEach(prop => {
    //     if (!new_convenzione.value[prop]) {
    //       validationErrors.value[prop] = true
    //     }else{
    //       delete validationErrors.value[prop]
    //     }
    //   })      
    //   return Object.keys(validationErrors.value).length > 0
    // }
    const resetNewConvenzione = () => {
      new_convenzione.value = {
        nome_convenzione: '',
        agente: null,
        offerte: {
          fix: {
            ee: null,
            gas: null,
          },
          index: {
            ee: null,
            gas: null
          }
        },
        internal: 0,
        file: null
      }
    }

    const isDisabledSendNewConvenzione = computed(() => {
      let {nome_convenzione, agente, offerte, file} = new_convenzione.value

      let array_check = [
        nome_convenzione == '',
        agente == null,
        file == null
      ]
      if (!types_offerte.value[0].selected && !types_offerte.value[1].selected) {
        array_check.push(true)
      }
      if (types_offerte.value[0].selected) {
        array_check.push(offerte.fix.ee == null)
        array_check.push(offerte.fix.gas == null)
      }

      if (types_offerte.value[1].selected) {
        array_check.push(offerte.index.ee == null)
        array_check.push(offerte.index.gas == null)
      }      
      return array_check.some(elemento => elemento === true)
    })

    return {
      loading,
      convenzioni,
      validationErrors,
      services,
      moment,
      getInfoOfferta,
      dialog_create_convenzione,
      showNewConvenzioneCard,
      toggleNewConvenzioneCard,
      agenti_offerte,
      selectedAgente,
      onSelectionAgente,
      offerte_elettrico,
      offerte_gas,
      new_convenzione,
      // types_tipologia,
      handleFile,
      resetNewConvenzione,
      sendNewConvenzione,
      setActiveConvenzione,
      isConvenzioneInactive,
      activeConvenzioneLoading,
      types_offerte,
      isDisabledSendNewConvenzione,
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.card {
  font-family: 'Montserrat', sans-serif;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  padding: 1.5rem;
}

.card > .flex {
  justify-content: space-between;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 1rem;
}

.card h4 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.card > .flex .col-10 {
  display: flex;
  justify-content:center;
  align-items: center;
}

:deep(.p-button) {
  background-color: #3498db;
  border-color: #3498db;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 0.7rem 1.2rem;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

:deep(.p-button:hover) {
  background-color: #2980b9;
  border-color: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

:deep(.p-button:active) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

:deep(.p-button .p-button-icon) {
  margin-right: 0.5rem;
}

/* Override per il pulsante Salva */
.col-12.flex.justify-content-center.m-2 :deep(.p-button) {
  padding: 0.8rem 2rem;
  font-size: 1rem;
}

/* Stile per la card di nuova convenzione */
.new-convenzione-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.new-convenzione-card.expanded {
  background-color: white;
}

.new-convenzione-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.new-convenzione-card-header h3 {
  margin: 0;
  color: #3498db;
  font-size: 1.2rem;
  font-weight: 600;
}

/* Button close con colore contrastante */
.new-convenzione-card-header :deep(.p-button.p-button-text) {
  color: #666;
  background-color: #f0f0f0;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.new-convenzione-card-header :deep(.p-button.p-button-text:hover) {
  background-color: #e0e0e0;
  color: #333;
}

.new-convenzione-card-header :deep(.p-button.p-button-text .p-button-icon) {
  margin-right: 0;
  font-size: 1rem;
}

.new-convenzione-card-content {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e6e6e6;
}

/* Card per ogni gruppo di convenzioni */
.card .card {
  margin-top: 1rem;
  padding: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.card .card > .col-2 {
  background-color: #f5f7fa;
  font-weight: 600;
  font-size: 1.1rem;
  color: #3498db;
  padding: 1.2rem;
  border-right: 1px solid #e6e6e6;
}

.card .card > .col-10 {
  padding: 1.2rem;
}

/* DataTable styles */
:deep(.p-datatable) {
  margin-bottom: 1.2rem;
}

:deep(.p-datatable-header) {
  background-color: #f5f7fa;
  padding: 0.8rem 1rem;
  font-weight: 600;
  color: #3498db;
  border-bottom: 1px solid #e6e6e6;
}

:deep(.p-datatable-thead > tr > th) {
  background-color: #f8f9fa;
  color: #666;
  font-weight: 600;
  padding: 0.8rem 1rem;
}

:deep(.p-datatable-tbody > tr > td) {
  padding: 0.7rem 1rem;
  border-bottom: 1px solid #f2f2f2;
}

:deep(.p-datatable-tbody > tr:nth-child(even)) {
  background-color: #fafafa;
}

/* Form elements */
label {
  display: block;
  font-weight: 500;
  color: #555;
  margin-bottom: 0.5rem;
}

:deep(.p-inputtext),
:deep(.p-dropdown) {
  width: 100%;
  margin-bottom: 0.7rem;
  height: 42px; /* Altezza fissa per uniformità */
}

:deep(.p-dropdown .p-dropdown-label) {
  padding-top: 8px; /* Centrare verticalmente il testo */
}

:deep(.p-checkbox) {
  margin-right: 0.5rem;
}

/* File upload */
.button-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  margin: 1rem 0;
}

.button-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.button-wrapper .label {
  background-color: #3498db;
  color: white;
  font-weight: 600;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  width: 100%;
  text-align: center;
}

.button-wrapper .label::before {
  content: '\f093'; 
  font-family: 'PrimeIcons', sans-serif;
  margin-right: 8px;
  display: inline-block;
}

.button-wrapper:hover .label {
  background-color: #2980b9;
}

.button-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

/* File selection info */
.m-1 {
  margin: 0.5rem 0;
  color: #555;
  font-size: 0.9rem;
}

/* Error messages */
.p-error {
  color: #e74c3c;
  font-size: 0.8rem;
  margin-top: 0.3rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .card .card {
    flex-direction: column;
  }
  
  .card .card > .col-2,
  .card .card > .col-10 {
    width: 100%;
  }
  
  .card .card > .col-2 {
    border-right: none;
    border-bottom: 1px solid #e6e6e6;
  }
}
</style>